import React from 'react';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Emoji from 'a11y-react-emoji';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import {data} from '../constants/data'

const name = data.name;
const description = data.description;
const greeting = data.greeting;
const li = data.linkedin;
const gh = data.github;
const em = data.email;
const chineseDescription = data.chineseDescription

const Img = styled('img')({
  margin: 'auto',
  display: 'block',
  maxWidth: '20%',
  maxHeight: '20%',
});


export default function Info() {

const img = (
  <Img
      alt="profile"
      src="assets/img/profile_update.JPG"
    />
  )
const info = (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ flex: '1 0 auto' }}>
        <Typography variant="h5" component="div">
          {name}
          <Button size="small" sx={{ minWidth: 50 }} href={gh}><GitHubIcon/></Button>
          <Button size="small" sx={{ minWidth: 50 }} href={li}><LinkedInIcon/></Button>
          <Button size="small" sx={{ minWidth: 50 }} href={em}><AlternateEmailIcon/></Button>

        </Typography>
        <br />
        <Typography variant="h5" component="div">
          <Emoji symbol="👋" label="wave" />
        </Typography>
        <Typography variant="body2" component="div">
          {chineseDescription}
          <br />
          {greeting}
          <Emoji symbol="🙏" label="thank" />
        </Typography>
        <br />
        <Typography variant="body2">
          {description}
        </Typography>
        <Box sx={{mb: 18}}/>

      </CardContent>
    </Box>
);

  return (
    <Card sx={{ display: 'flex', minWidth: 275 }} variant="outlined">
      {img}
      {info}
    </Card>
  );
}